/* eslint-disable import/no-cycle */
import { permissionsConstants } from '../../constants'

const getPermissions = (type, permissions) => {
  if (!type || !permissions) return false
  return permissionsConstants.accounts[type][permissions]
}
export { getPermissions }
